module.exports = __webpack_public_path__ + "static/img/can-pineapple.695ef0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-pineapple.png
// module id = LH5y
// module chunks = 0